/*
 * Relief3 funnel attribution
 *
 * 1. Capture & persist: on first touch, read r3_funnel_id / r3_entry_domain from
 *    the URL and write a first-party cookie (30-day TTL). First touch wins as a
 *    unit — once the cookie exists it is never modified.
 * 2. Pass into checkout: on click of any relief3.com/cart link, append the stored
 *    funnel params onto the innermost /checkout return_to so they land on the
 *    final checkout URL (readable by the Customer Events pixel via
 *    event.context.document.location.href).
 */
(function () {
  "use strict";

  var COOKIE_NAME = "r3_funnel_attribution";
  var TTL_DAYS = 30;
  var CART_LINK_MATCH = "relief3.com/cart";

  function safeDecode(value) {
    if (value == null) return value;
    try {
      return decodeURIComponent(value);
    } catch (e) {
      return value;
    }
  }

  function readCookie(name) {
    var escaped = name.replace(/([.*+?^${}()|[\]\\])/g, "\\$1");
    var match = document.cookie.match("(?:^|; )" + escaped + "=([^;]*)");
    return match ? safeDecode(match[1]) : null;
  }

  function getAttribution() {
    var raw = readCookie(COOKIE_NAME);
    if (!raw) return null;
    try {
      var parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object" && parsed.r3_funnel_id)
        return parsed;
    } catch (e) {}
    return null;
  }

  function writeCookie(obj) {
    var expires = new Date(
      Date.now() + TTL_DAYS * 24 * 60 * 60 * 1000,
    ).toUTCString();
    document.cookie =
      COOKIE_NAME +
      "=" +
      encodeURIComponent(JSON.stringify(obj)) +
      "; expires=" +
      expires +
      "; path=/; SameSite=Lax";
  }

  /* ---- 1. Capture & persist (first-touch wins as a unit) ---- */
  function captureFromUrl() {
    if (getAttribution()) return; // first touch already recorded — never overwrite

    var params = new URLSearchParams(window.location.search);
    var funnelId = params.get("r3_funnel_id");
    if (!funnelId) return;

    var entryDomainRaw = params.get("r3_entry_domain");
    writeCookie({
      r3_funnel_id: funnelId,
      r3_entry_domain: entryDomainRaw ? safeDecode(entryDomainRaw) : null,
      ts: Date.now(),
    });
  }

  /* ---- 2. Pass funnel params into the checkout URL ---- */

  function buildFunnelQuery(attr) {
    var q = "r3_funnel_id=" + encodeURIComponent(attr.r3_funnel_id);
    if (attr.r3_entry_domain) {
      q += "&r3_entry_domain=" + encodeURIComponent(attr.r3_entry_domain);
    }
    return q; // plain (unencoded) "a=b&c=d"
  }

  // Shopify checkout links on these pages look like:
  //   https://relief3.com/cart/clear?return_to=%2Fcart%2Fadd%3Fitems%5B%5D...%26return_to%3D%252Fcheckout
  // URLSearchParams.get('return_to') decodes one layer, leaving the *inner*
  // return_to target (e.g. "%2Fcheckout") still encoded once. We append our params
  // to that inner target so the browser ultimately lands on /checkout?r3_funnel_id=...
  function rewriteCheckoutUrl(url, attr) {
    var u;
    try {
      u = new URL(url, window.location.origin);
    } catch (e) {
      return url;
    }

    var outerReturn = u.searchParams.get("return_to");
    if (!outerReturn) return url;

    var plainQuery = buildFunnelQuery(attr);

    // Single hop: return_to points straight at /checkout.
    if (/^\/checkout(\?|$)/i.test(outerReturn)) {
      var sep = outerReturn.indexOf("?") !== -1 ? "&" : "?";
      u.searchParams.set("return_to", outerReturn + sep + plainQuery);
      return u.toString();
    }

    // Multi hop: the decoded outer return_to contains another return_to=<target>,
    // where <target> is still encoded one level (matching its position).
    var m = outerReturn.match(/([?&]return_to=)([^&]*)/);
    if (m) {
      var innerTarget = m[2]; // e.g. "%2Fcheckout"
      var innerSep = /%3F|%253F|\?/i.test(innerTarget) ? "&" : "?";
      var appended = innerTarget + encodeURIComponent(innerSep + plainQuery);
      var newOuter = outerReturn.replace(m[0], m[1] + appended);
      u.searchParams.set("return_to", newOuter);
      return u.toString();
    }

    return url;
  }

  function isCartLink(href) {
    return typeof href === "string" && href.indexOf(CART_LINK_MATCH) !== -1;
  }

  function onCheckoutClick(event) {
    var attr = getAttribution();
    if (!attr) return; // no funnel context — clean pass-through

    var anchor =
      event.target && event.target.closest
        ? event.target.closest("a[href]")
        : null;
    if (!anchor) return;

    var current = anchor.getAttribute("href");
    if (!isCartLink(current)) return;
    if (current.indexOf("r3_funnel_id") !== -1) return; // already decorated

    var rewritten = rewriteCheckoutUrl(current, attr);
    if (rewritten && rewritten !== current) {
      anchor.setAttribute("href", rewritten);
    }
  }

  captureFromUrl();
  document.addEventListener("click", onCheckoutClick, true);

  window.r3GetFunnelAttribution = getAttribution;
})();
